module.exports = __webpack_public_path__ + "img/1.9f32c89b.jpg";